import { useContext } from 'react';
import { useMst } from '../../../models';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import { observer } from 'mobx-react-lite';
import ThemeContext from 'contexts/themeContext';
import Button from 'components/bootstrap/Button';
import Txt from 'components/common/ui/Txt';

const ButtonClockTime = ({ handleCheckinCheckout, isButtonLocked }) => {
  const { attend: attendStore } = useMst();
  const { t } = useTranslation();
  const { mobileDesign } = useContext(ThemeContext);

  const { startTime2: startTime, endTime2: endTime } = get(attendStore, 'datas.info', {});
  const isOffWorkDisabled = !mobileDesign && attendStore?.get?.status === 4;
  const isDisabled = isOffWorkDisabled || (!mobileDesign && isButtonLocked);

  const renderBtnTxt = () => {
		if (isPunchDone) return t('attendance.checkoutDone');
		if (checkingStatus === 2) return t('attendance.checkoutBtn');
		return t('attendance.checkinBtn'); // 1, 8(휴일) 등
	};

  // 1: 출근 전 / 2: 출근함 / 4: 퇴근함 / 8: 비근무일
  const checkingStatus = get(attendStore, 'datas.info.status', 1);
  // 비근무일(8)은 출퇴근 모두 완료되면 더 이상 타각 불가 (기존 AttendanceHome 로직)
  const holidayDone = checkingStatus === 8 && !!startTime && !!endTime;
  const isPunchDone = checkingStatus === 4 || holidayDone;
  // 버튼 아이콘: 출근 전이면 work_on, 그 외 work_off
	const btnIconClass = checkingStatus === 2 || isPunchDone ? 'work_off' : 'work_on';

  return (
    <Button type='button'
      className={`btn_punch ${btnIconClass}`}
      data-bs-toggle="modal"
      data-bs-target="#changeLocationModal"
      disabled={isDisabled}
      onClick={isDisabled ? undefined : handleCheckinCheckout}
    >
      <Txt as='span' weight='bold' color='white'>{renderBtnTxt()}</Txt>
    </Button>
  );
};

export default observer(ButtonClockTime);